import "../_imports/common";
import "../_imports/metronic";

// Font Awesome
import '@fortawesome/fontawesome-free/css/all.css';

// Custom
import '../../scss/index.scss';

class IndexPage {

    // Inizializzazione proprietà
    constructor() {

        this.bindEvents();
    }

    // Operazioni da eseguire sulla document.ready()
    run() { /* empty */ }

    // Binding agli eventi (richiamata nel costruttore)
    private bindEvents() { /* empty */}
}

$(() => {
    const page = new IndexPage();
    page.run();
});